var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"wrap-80"},[_c('BreadCrumb'),_c('PayDet',{attrs:{"orderAddress":_vm.orderAddress,"orderBasic":_vm.orderBasic,"orderDetails":_vm.orderDetails}}),_c('PayType',{attrs:{"orderBasic":_vm.orderBasic}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }